// Coordinate extraction shared by the on-screen map (MapViz) and the PNG
// exporter, so both place markers from exactly the same rows: one point per
// result row with finite numeric latitude/longitude and a display label.
import { geoField } from '../charts';

// Returns null when the data has no lat/lon columns at all; an empty array
// means the columns exist but hold no usable coordinates.
export function mapPoints(rows, fields, config) {
  const latField = geoField(fields, 'latitude');
  const lonField = geoField(fields, 'longitude');
  if (!latField || !lonField) return null;

  const labelKey = (config && config.labelField) || 'name';
  return (rows || [])
    .map((row) => ({
      row,
      lat: coordinate(row[latField.key]),
      lon: coordinate(row[lonField.key]),
      label: labelText(row, labelKey)
    }))
    .filter((point) => Number.isFinite(point.lat) && Number.isFinite(point.lon));
}

// Missing coordinates must not become 0° (Number(null) is 0), or empty rows
// would be plotted in the Gulf of Guinea.
function coordinate(value) {
  return value === null || value === undefined || value === '' ? NaN : Number(value);
}

function labelText(row, key) {
  const raw = row[key];
  return raw === null || raw === undefined ? '' : String(raw);
}

// Geographic bounds of a list of points, or null when there are none.
export function pointsBounds(points) {
  if (!points || points.length === 0) return null;
  let north = -Infinity;
  let south = Infinity;
  let east = -Infinity;
  let west = Infinity;
  for (const point of points) {
    north = Math.max(north, point.lat);
    south = Math.min(south, point.lat);
    east = Math.max(east, point.lon);
    west = Math.min(west, point.lon);
  }
  return { north, south, east, west };
}
